import { render, staticRenderFns } from "./ArticleTree.vue?vue&type=template&id=10559523&scoped=true&"
import script from "./ArticleTree.vue?vue&type=script&lang=js&"
export * from "./ArticleTree.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTree.vue?vue&type=style&index=0&id=10559523&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10559523",
  null
  
)

export default component.exports